import { withConfig } from "@/utils/withConfig";
import { GiftAid } from "./GiftAid";
import type { GiftAidProps } from "./GiftAidProps";

export * from "./GiftAid";
export * from "./GiftAidProps";

export const GiftAidWithConfig = withConfig<GiftAidProps>(GiftAid, "gift_aid");
